// istanbul ignore file

import { StandaloneCookbookData } from '../data/StandaloneCookbookData';

export const CLOUDINARY_COOKBOOK_DATA_GLOBAL_KEY = 'CLOUDINARY_COOKBOOK_DATA';

/**
 * Hydrated app needs to know the data which was used to render the page
 * on the server side. It is passed through the global object, so we need
 * to inform TypeScript that we expect a string with this data structure.
 */
declare global {
  interface Window {
    [CLOUDINARY_COOKBOOK_DATA_GLOBAL_KEY]: StandaloneCookbookData;
  }
}

export const getHydrateData = () => window[CLOUDINARY_COOKBOOK_DATA_GLOBAL_KEY];
